<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     toast: useToast(),
     data: [],
     user_id: '',
     from_date: '',
     to_date: '',
     lead_stage_id: '',
     branch_id: '',
     pagination: {
      current_page: 1,
      per_page: 25,
      last_page: 1,
      total: 0,
      links: []
     },
    };
  },

  computed: {
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },
  methods: {
    
   async getLeads(user_id, from_date, to_date, lead_stage_id, branch_id = '', page = 1){
    this.errors = {};
    this.setLoading(true); 
    try{
      this.user_id = user_id;
      this.from_date = from_date;
      this.to_date = to_date;
      this.lead_stage_id = lead_stage_id;
      this.branch_id = branch_id;

      const params = {
       page, 
       user_id,
       from_date,
       to_date,
       lead_stage_id,
       branch_id,
      };
     const query_string = new URLSearchParams(params).toString();
     const response = await axios.get(`/leads?${query_string}`);
     this.data = response.data.data.data;
     this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
     };
    }catch(error){
     this.toast.error(error.message);
    }finally{
     this.setLoading(false); 
    }
   },

   async changePage(url, resourceMethod, ...otherArgs) {
    if (!url) return;
    const page = new URL(url, window.location.origin).searchParams.get("page");
    if (!page) return;
    if(typeof this[resourceMethod] === 'function'){
     await this[resourceMethod](...otherArgs, page);
    }else{
     this.toast.error("Resource method not found.");
    }
   },

  },
};
</script>

<template>

<div class="modal fade" id="lead_detail_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">Leads List</h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
 <i class="ti ti-x"></i>
 </button>
</div>

<div class="modal-body pb-0">
<div class="custom-datatable-filter table-responsive">
<table class="table datatable thead-light" v-if="data?.length">
<thead>
 <tr>
  <th>#</th>
  <th>Name</th>
  <th>Email</th>
  <th>Mobile</th>
 </tr>
</thead>
<tbody>
 <tr v-for="(row, index) in data" :key="row.id"> 
  <td>{{ serialNo + index + 1 }}.</td>
  <td><a :href="`/crm/leads-details/${row.id}`" target="_blank">{{ row.name }}</a></td>
  <td>{{ row.email }}</td>
  <td>{{ row.mobile }}</td>
 </tr>
</tbody>
</table>
 
 <div class="text-muted text-center" v-else> No record found. </div>

</div>

<nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
<ul class="pagination pagination-sm">
 <li v-for="(link, index) in pagination.links" :key="index" :class="['page-item', { active: link.active, disabled: !link.url }]">
  <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url, 'getLeads', user_id, from_date, to_date, lead_stage_id, branch_id)"></a>
 </li>
</ul>
</nav>

</div>
</div>
</div>
</div>

</template>
